import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Badge } from '../ui/badge';
import { Gauge, AlertTriangle } from 'lucide-react';
import { format, parseISO } from 'date-fns';

export const AttendanceFillRateCard = ({ avgFillRate, underAttendedSessions = [], onRowClick, testId = 'fill-rate-card' }) => (
  <Card data-testid={testId}>
    <CardHeader>
      <CardTitle className="font-heading text-base flex items-center gap-2">
        <Gauge className="w-4 h-4 text-blue-600" />
        Attendance Fill Rate
      </CardTitle>
      <CardDescription className="text-xs">Actual vs Expected attendance — under-attended sessions (below 50%) flagged</CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="flex items-baseline gap-2">
        <span className="text-3xl font-bold font-heading">{avgFillRate != null ? `${avgFillRate}%` : '—'}</span>
        <span className="text-sm text-muted-foreground">average fill rate across sessions with expected attendance set</span>
      </div>
      {underAttendedSessions.length > 0 ? (
        <div className="max-h-64 overflow-y-auto border rounded-lg">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Session</TableHead>
                <TableHead>Project</TableHead>
                <TableHead>Date</TableHead>
                <TableHead>Expected</TableHead>
                <TableHead>Actual</TableHead>
                <TableHead>Fill Rate</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {underAttendedSessions.map(s => (
                <TableRow
                  key={s.session_id}
                  className={onRowClick ? 'cursor-pointer hover:bg-muted/50' : ''}
                  onClick={() => onRowClick && onRowClick(s)}
                  data-testid={`under-attended-${s.session_id}`}
                >
                  <TableCell className="text-sm">{s.title}</TableCell>
                  <TableCell className="text-sm">{s.project_title}</TableCell>
                  <TableCell className="text-sm">{s.session_date ? format(parseISO(s.session_date), 'MMM d, yyyy') : '—'}</TableCell>
                  <TableCell className="text-sm">{s.expected_count}</TableCell>
                  <TableCell className="text-sm">{s.attended_count}</TableCell>
                  <TableCell>
                    <Badge className="bg-red-100 text-red-800 flex items-center gap-1 w-fit">
                      <AlertTriangle className="w-3 h-3" />
                      {s.fill_rate}%
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <p className="text-center text-muted-foreground py-4 text-sm">No under-attended sessions in the current filter</p>
      )}
    </CardContent>
  </Card>
);

export default AttendanceFillRateCard;
